export const theme = {
  primary: '#c8102e',
  primaryLight: '#fde8ec',
  shadow: 'rgba(200, 16, 46, 0.08)',
  gradient: 'linear-gradient(125deg, #4a0e0e 0%, #8b1a1a 42%, #c8102e 100%)',
  overlay: 'radial-gradient(ellipse 50% 60% at 85% 40%, rgba(255, 180, 100, 0.15) 0%, transparent 55%)'
}

export const pageMeta = {
  title: '智慧党建管理系统',
  badge: '数字化赋能基层党建',
  description:
    '融合移动互联网、大数据分析与人文关怀，打造组织生活、党员发展、党费管理、学习培训、考核评价全流程一体化党建平台，助力基层党组织标准化规范化建设。',
  stats: [
    { value: '组织', label: '生活管理' },
    { value: '党员', label: '发展全流程' },
    { value: '学习', label: '培训考核' },
    { value: '100%', label: '安全合规' }
  ]
}

export const sections = {
  features: {
    title: '核心功能',
    desc: '六大功能模块覆盖党建工作全流程，以数字化技术驱动基层党建工作提质增效。'
  },
  whyUs: {
    title: '为什么选择我们',
    desc: '深耕政务党建信息化领域多年，以技术实力与行业经验赢得客户信赖。'
  },
  related: {
    title: '相关产品',
    desc: '探索更多小智科技政务数字化解决方案。'
  }
}

export const features = [
  {
    icon: '📋',
    title: '组织生活管理',
    desc: '支持"三会一课"、主题党日、民主评议、组织生活会等组织生活在线发起、签到、记录与归档，自动提醒到期事项，确保组织生活规范有序开展。'
  },
  {
    icon: '🌱',
    title: '党员发展全流程',
    desc: '覆盖入党申请、积极分子培养、发展对象考察、预备党员转正全流程线上管理，节点自动提醒、材料电子化归档，确保发展程序规范透明。'
  },
  {
    icon: '💰',
    title: '党费收缴管理',
    desc: '支持党费标准自动计算、在线缴纳、收缴统计与公示，对接银行支付渠道，实现党费收缴透明化、便捷化，减轻党务工作者负担。'
  },
  {
    icon: '📚',
    title: '在线学习培训',
    desc: '整合视频课程、图文资料、在线考试等资源，支持学习计划制定、学习进度跟踪、学时统计，推动党员学习教育常态化制度化。'
  },
  {
    icon: '📊',
    title: '党建考核评价',
    desc: '建立可配置的党建考核指标体系，支持自评、互评、上级考评多维度评价，自动生成考核报告与排名，以考核促落实。'
  },
  {
    icon: '🖥️',
    title: '数据驾驶舱',
    desc: '可视化呈现组织架构、党员分布、活动开展、学习完成率等关键指标，为上级党组织决策提供数据支撑，实现党建工作的精准管理。'
  }
]

export const architecture = {
  variant: 'party',
  title: '智慧党建管理系统',
  desc: '以"展示—应用—基础"三层架构为核心，面向党委、支部、党员等多类服务对象，覆盖组织工作、党务工作、学习教育等全场景，多端协同构建智慧党建解决方案。',
  serviceObjects: ['党委', '总支/支部', '党员', '入党积极分子'],
  terminals: ['党建微信小程序', 'PC门户', '智能大屏', '一体机', '管理后台'],
  layers: [
    {
      name: '展示层',
      sectionTitle: '党建大数据',
      items: [
        '党组织大数据',
        '党员大数据',
        '活动大数据',
        '学习大数据',
        '考核大数据',
        '荣誉大数据',
        '党费大数据',
        '干部大数据',
        '党员画像',
        '统计分析'
      ]
    },
    {
      name: '应用层',
      groups: [
        {
          title: '组织工作',
          items: [
            '党组织管理',
            '党员管理',
            '党员发展全程纪实',
            '流动党员',
            '党内职务',
            '党组织关系转接',
            '政治生日',
            '党员积分'
          ]
        },
        {
          title: '党务工作',
          items: [
            '三会一课',
            '组织生活',
            '主题党日',
            '民主生活会',
            '荣誉管理',
            '民主评议',
            '通知公告',
            '党费缴纳'
          ]
        },
        {
          title: '纪检工作',
          items: ['警示教育', '廉政谈话', '违纪处理', '承诺书']
        },
        {
          title: '宣传工作',
          items: ['党建要闻', '支部动态', '专题专栏', '光荣榜']
        },
        {
          title: '学习教育',
          items: ['专题学习', '考试中心', '学习资源库']
        },
        {
          title: '党群工作',
          items: ['志愿服务', '党员关怀', '问卷调查', '投票管理', '书记信箱']
        },
        {
          title: '党建台账',
          items: [
            '党委工作台账',
            '支部工作台账',
            '纪检工作台账',
            '考核工作台账',
            '党员手册'
          ]
        },
        {
          title: '数据中心',
          items: ['组织数据', '党员数据', '登录数据', '考核数据']
        }
      ]
    },
    {
      name: '基础层',
      items: [
        '党员资料库',
        '组织资料库',
        '考核资料库',
        '学习资料库',
        '活动资料库'
      ],
      extra: '+ N个扩展库'
    }
  ],
  footer: '多端协同 · 数据安全 · 等保测评 · 私有化部署'
}

export const whyUs = [
  {
    title: '政策合规',
    desc: '严格对标《中国共产党支部工作条例》等最新党内法规，确保系统功能与组织工作要求始终保持同步，助力基层党组织标准化建设。'
  },
  {
    title: '安全可控',
    desc: '支持私有化部署与等保测评认证，党员数据全链路加密存储与传输，细粒度权限管控，确保党务数据安全不出域。'
  },
  {
    title: '实战验证',
    desc: '已在湖北省多个党政机关、企事业单位成功落地，覆盖机关、事业、国企等多种组织形态，经受真实业务场景检验。'
  },
  {
    title: '快速部署',
    desc: '模块化架构设计，支持灵活配置与快速上线，提供专属实施团队与7×24运维保障服务，缩短建设周期。'
  }
]

export const scenarios = {
  label: '党建落地场景',
  title: '让组织生活、党员管理和学习考核更有章法',
  desc: '系统定位为"智慧党建工具"，帮助党务工作者从繁琐的事务性工作中解放出来，但关键决策、审批流程仍由党组织把关。',
  items: [
    {
      title: '组织生活规范化',
      desc: '在线发起"三会一课"与主题党日，自动提醒到期事项，签到记录与材料归档一站式完成，确保组织生活不走过场。'
    },
    {
      title: '党员发展管理',
      desc: '发展全流程节点可视化跟踪，材料电子化提交与审核，自动校验程序合规性，确保发展党员工作规范透明。'
    },
    {
      title: '党费收缴透明化',
      desc: '党费标准自动计算、在线缴纳与收缴统计，支持公示与对账，让党费管理更加规范便捷。'
    },
    {
      title: '学习教育常态化',
      desc: '整合学习资源，制定学习计划，跟踪学习进度与考试结果，推动党员学习教育走深走实。'
    }
  ],
  highlights: [
    { title: '移动便捷', desc: '支持手机端随时随地处理党务工作，消息推送及时提醒，让党建服务触手可及。' },
    { title: '规则可配置', desc: '可按本地组织规范配置考核指标、流程节点、提醒规则与报表模板，减少硬编码改造。' },
    { title: '数据可视化', desc: '多维度数据统计与可视化展示，辅助上级党组织掌握基层党建工作动态。' }
  ]
}

export const relatedProducts = [
  {
    icon: '👔',
    title: '干部管理',
    desc: '基于AI的干部全生命周期管理平台，涵盖选拔、考核、培养、监督等环节，实现干部管理的数字化与智能化。',
    route: '/cadre-management',
    color: '#0052d9'
  },
  {
    icon: '🌾',
    title: '数字乡村',
    desc: '乡村治理、智慧农业、便民服务、产业振兴全流程数字化，助力乡村振兴战略落地见效。',
    route: '/digital-village',
    color: '#0a6e4e'
  },
  {
    icon: '🛡️',
    title: '综合治理',
    desc: '网格化管理、事件处置、矛盾调解、指挥调度一体化平台，提升基层社会治理效能。',
    route: '/comprehensive-governance',
    color: '#531dab'
  }
]
